import {useLexicalComposerContext} from '@lexical/react/LexicalComposerContext';
import {useEffect} from 'react';

type Props = {
    isRtl?: boolean;
};

export const ThemeUpdater = ({isRtl}: Props) => {
    const [editor] = useLexicalComposerContext();

    useEffect(() => {
        editor.update(() => {
            const config = editor._config.theme;
            config.list = {
                ...config.list, // Keep the existing theme
                listitem: isRtl ? 'priority-editor__list-item-right' : 'priority-editor__list-item' // Update the theme
            };
        });
    }, [isRtl, editor]);

    return null;
};
